exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".showRelationshipsBetweenTwoFields__fieldSearchInputFlyout {\n  border: none;\n  width: 350px;\n}\n\n.showRelationshipsBetweenTwoFields__fieldSearchInputFlyout .ba-common-baseInput {\n  width: 100%;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/components/startingPoints/relationshipGraph/RelationshipWidgetContextMenu.scss
// module id = 392
// module chunks = 0